var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.addClasses},[_c('span',{class:[_vm.checkNotification(_vm.status) ? 'color-success':'color-danger']},[_vm._v(" "+_vm._s(_vm.getStatus(_vm.status))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }